import cx from 'classnames';
import type { HTMLAttributes } from 'react';
import css from './Card.module.scss';

interface ICardProps
  extends HTMLAttributes<HTMLDivElement | HTMLButtonElement> {
  className?: string;
}

export const Card = ({ className, ...rest }: ICardProps) => {
  const Component = rest.onClick ? 'button' : 'div';
  return <Component className={cx(css.card, className)} {...rest} />;
};
